import { preload } from "#/utils/LookupTableUtils.js";

export default function Preloader({ children }) {
  const init = useRef(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (init.current) {
      return;
    }

    // preload only once!
    init.current = true;

    Promise.all([
      // Preload lookup tables at the root of the app,
      // so that they are available in IndexedDB
      // for the rest of the app to use.
      preload(),
    ]).then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    // @todo this could be a nice place for a loading spinner or skeleton screen
    return null;
  }

  return children;
}
